import { useLocalizationContext } from "localization/LocalizationProvider";
import { Locales } from "localization/types";
import React from "react";
import { isDesktop } from "react-device-detect";
import { SummaryType } from "../../../types";
import { useContent } from "../details/utils";
import { Annotation, Card, Content, IconContainer, InfoContainer } from "./styles";
interface Props {
	data: string | number;
	label: string;
	icon: React.ReactNode;
	type: string;
	contentId: string;
}

function getOrdinal(n: number, locale: Locales = "en") {
	if (locale === "nl") {
		return "e";
	}
	var s = ["th", "st", "nd", "rd"],
		v = n % 100;
	return s[(v - 20) % 10] || s[v] || s[0];
}

const InfoCard: React.FC<Props> = (props) => {
	const message = useContent({ contentId: props.contentId, defaultId: props.label });
	const messageLowerCase = message[0].concat(message.substring(1, message.length).toLowerCase());

	const { locale } = useLocalizationContext();
	return (
		<Card id={props.type}>
			<InfoContainer>
				<Content>
					{props.type !== SummaryType.AWARD ? (
						props.data
					) : (
						<>
							{props.data}
							<sup>{getOrdinal(props.data as number, locale)}</sup>
						</>
					)}
				</Content>
				<Annotation>{isDesktop ? message : messageLowerCase}</Annotation>
			</InfoContainer>
			{isDesktop && <IconContainer>{props.icon}</IconContainer>}
		</Card>
	);
};

export default InfoCard;
